import { CONTEXT_TYPES } from '@dh-io-cscs/user-context-manager/dist/common/constants';
import { Environment, Product } from '@dh-io-emh/search-result-store';
import {
  ConfigService,
  GetProductPriceCustomerTypeEnum,
  GetProductPriceTaxProfileEnum,
  Environment as PlsEnvironment,
  PlsService,
  ProductPriceResponseDto,
  RuntimeConfig,
} from '@dh-io-pls/pls-store';

// Add types here as needed
export type PlsPriceTypes = 'NET_EX_SHOWROOM';

export const getRequestMode = (product: Product): 'overseas' | 'default' =>
  product.source === 'VX' ? 'overseas' : 'default';

export const getFcisEnvironment = (emhEnv: Environment): 'production' | 'test' =>
  emhEnv === 'prod' ? 'production' : 'test';

export const getFcisCustomerType = (customerType?: CONTEXT_TYPES): 'business' | 'private' =>
  customerType === CONTEXT_TYPES.B2B ? 'business' : 'private';

export const getPlsEnvironment = (emhEnv: Environment): PlsEnvironment =>
  emhEnv.startsWith('dev') ? 'dev' : (emhEnv as PlsEnvironment);

export const getPlsTaxProfile = (customerType?: CONTEXT_TYPES): GetProductPriceTaxProfileEnum =>
  customerType === CONTEXT_TYPES.B2B ? GetProductPriceTaxProfileEnum.Net : GetProductPriceTaxProfileEnum.Gross;

export const getPlsCustomerType = (customerType?: CONTEXT_TYPES): GetProductPriceCustomerTypeEnum =>
  customerType === CONTEXT_TYPES.B2B ? GetProductPriceCustomerTypeEnum.B2B : GetProductPriceCustomerTypeEnum.B2C;

export const getPlsPriceData = async ({
  product,
  apiMode,
  shopCountry,
  customerType,
  postCode,
  lang,
  jweToken,
  activeCustomerGroupId,
}: {
  product: Product;
  apiMode: Environment;
  shopCountry: string;
  lang: string;
  customerType?: CONTEXT_TYPES;
  postCode: string | null;
  jweToken: string | null;
  activeCustomerGroupId?: string;
}) => {
  const plsConfigService = ConfigService.getInstance();
  const plsService = PlsService.getInstance();
  const plsEnv = getPlsEnvironment(apiMode);
  const plsConfig = (await plsConfigService.getConfig(shopCountry, plsEnv)) as RuntimeConfig;
  const plsApiConfig = plsConfig.pls[plsEnv];

  plsService.init(plsApiConfig);

  return plsService.getPriceData({
    product: product,
    market: shopCountry,
    customerType: getPlsCustomerType(customerType),
    taxProfile: getPlsTaxProfile(customerType),
    environment: plsEnv,
    postCode: postCode ?? undefined,
    language: lang,
    customerWebToken: jweToken ?? undefined,
    customerGroup: activeCustomerGroupId,
  });
};

export const findPriceBreakDownItem = (plsData: ProductPriceResponseDto, priceType: PlsPriceTypes) =>
  plsData.priceBreakDown.find((item) => item.type === priceType);
